<p>
  element-render-hotspot works!
</p>
